import api from '@/api'

const { $pricing, $academic } = api;


export const { $types } = $pricing;
export const { $careers, $subjects, $studyPlans, $degrees, $setting } = $academic;
